import Translate from '../../../modules/util/Translate'
import { LocaleMessages } from 'vue-i18n'

export const balanceSearch: LocaleMessages = {
  en: {
    balanceSearch: {
      head: {
        capacityOrMindisp: 'Search by Capacity or<br/>Minimum display',
        specification: 'Search by specification,<br/>function or application',
        modelName: 'Search by model name'
      },
      label: {
        capacitySearch: 'Search by Capacity',
        minDispSearch: 'Search by Minimum display',
        specSearch: 'Specification',
        functionSearch: 'Function',
        applicationSearch: 'Application'
      },
      column: {
        modelName: 'Model name',
        capacity: 'Capacity',
        minDisplay: 'Minimum display',
        panSize: 'Pan size'
      },
      notice: 'You can search by part of model name',
      sfa: {
        specs: {
          unibloc: 'Unibloc installed',
          light: 'Backlight display',
          menu: 'Menu operation key',
          dry: 'Dry battery',
          dual: 'Dual range'
        },
        funcs: {
          easy: 'Easy Setting',
          internal: 'Internal Calibration',
          clock: 'Bulk-in Clock',
          windows: 'Windows®Direct',
          iso: 'ISO Calibration Report'
        },
        apps: {
          animal: 'Animal',
          gravity: 'Specific gravity measurement',
          comparator: 'Comparator function',
          formulation: 'Formulation mode',
          piece: 'Piece counting',
          carat: 'Carat measurement'
        }
      }
    }
  },
  ja: {
    balanceSearch: {
      head: {
        capacityOrMindisp: 'ひょう量・最小表示から<br/>検索する',
        specification: '機能から検索する',
        modelName: '機種から検索する'
      },
      label: {
        capacitySearch: 'ひょう量',
        minDispSearch: '最小表示',
        specSearch: '仕様',
        functionSearch: '便利な機能',
        applicationSearch: '用途'
      },
      column: {
        modelName: '型式',
        capacity: 'ひょう量',
        minDisplay: '最小表示',
        panSize: '皿の大きさ'
      },
      notice: '※形名の一部を入力しても検索できます。（ % や * は不要 ）',
      sfa: {
        specs: {
          unibloc: 'UniBloc搭載',
          light: 'バックライト液晶表示',
          menu: 'メニュー操作キー',
          dry: '電池駆動可能',
          dual: 'デュアルレンジ対応'
        },
        funcs: {
          easy: '簡単設定',
          internal: '校正分銅内蔵',
          clock: '時計機能内蔵',
          windows: 'Windows®直結機能',
          iso: 'ISOキャリブレーションレポート'
        },
        apps: {
          animal: '動物測定',
          gravity: '比重測定機能',
          comparator: 'コンパレータ（合否判定）',
          formulation: '製剤モード',
          piece: '個数測定（カウンティングスケール）',
          carat: 'カラット（宝石）計量'
        }
      }
    }
  },
  'zh-hant': {
    balanceSearch: {
      head: {
        capacityOrMindisp: '按秤量或精密度搜索',
        specification: '按規格、功能或應用搜尋',
        modelName: '按機型型號搜尋'
      },
      label: {
        capacitySearch: '按秤量搜尋',
        minDispSearch: '按精密度搜尋',
        specSearch: '規格',
        functionSearch: '功能',
        applicationSearch: '應用'
      },
      column: {
        modelName: '機型型號',
        capacity: '秤量',
        minDisplay: '精密度',
        panSize: '秤盤尺寸'
      },
      notice: '您可以按型號部分名稱搜索',
      sfa: {
        specs: {
          unibloc: '搭載Unibloc一體成型感測器',
          light: '背光顯示',
          menu: 'MENU操作鍵',
          dry: '乾電池',
          dual: '兩段式精度範圍'
        },
        funcs: {
          easy: '簡單設定',
          internal: '內部校準',
          clock: '計時器功能',
          windows: '天平免軟體直傳電腦',
          iso: 'ISO 校正報告'
        },
        apps: {
          animal: '小動物用模式',
          gravity: '固液體比重測定',
          comparator: '檢重模式',
          formulation: '配方加總模式',
          piece: '內建計數功能',
          carat: '克拉計算功能'
        }
      }
    }
  },
  es: {
    balanceSearch: {
      head: {
        capacityOrMindisp: 'Buscar por capacidad o<br/>pantalla mínima',
        specification: 'Buscar por especificación,<br/> función o aplicación',
        modelName: 'Buscar por nombre de modelo'
      },
      label: {
        capacitySearch: 'Buscar por capacidad',
        minDispSearch: 'Buscar por pantalla mínima',
        specSearch: 'Especificación',
        functionSearch: 'Función',
        applicationSearch: 'Aplicaciones'
      },
      column: {
        modelName: 'Nombre del modelo',
        capacity: 'Capacidad',
        minDisplay: 'Visualización mínima',
        panSize: 'Tamaño de la bandeja'
      },
      notice: 'Puede buscar por parte del nombre del modelo',
      sfa: {
        specs: {
          unibloc: 'Unibloc instalado',
          light: 'Pantalla retroiluminada',
          menu: 'Tecla de operación del menú',
          dry: 'Batería seca',
          dual: 'Doble rango'
        },
        funcs: {
          easy: 'Fácil configuración',
          internal: 'Calibración interna',
          clock: 'Reloj de entrada a granel',
          windows: 'Windows®Direct',
          iso: 'Informe de calibración ISO'
        },
        apps: {
          animal: 'Animal',
          gravity: 'Medición de la gravedad específica',
          comparator: 'Función de comparación',
          formulation: 'Modo de formulación',
          piece: 'Conteo de piezas',
          carat: 'Medición de quilates'
        }
      }
    }
  },
  'pt-br': {
    balanceSearch: {
      head: {
        capacityOrMindisp: 'Pesquise por Capacidade ou<br/>Exibição mínima',
        specification: 'Pesquise por especificação,<br/>função ou aplicação',
        modelName: 'Pesquise pelo nome do modelo'
      },
      label: {
        capacitySearch: 'Pesquise por Capacidade',
        minDispSearch: 'Pesquisar por exibição mínima',
        specSearch: 'Especificação',
        functionSearch: 'Função',
        applicationSearch: 'Aplicações'
      },
      column: {
        modelName: 'Nome do modelo',
        capacity: 'Capacidade',
        minDisplay: 'Exibição mínima',
        panSize: 'Tamanho da panela'
      },
      notice: 'Você pode pesquisar por parte do nome do modelo',
      sfa: {
        specs: {
          unibloc: 'Instalado Unibloc',
          light: 'Exibição de luz de fundo',
          menu: 'Tecla de operação do menu',
          dry: 'Célula seca',
          dual: 'Faixa dupla'
        },
        funcs: {
          easy: 'Configuração fácil',
          internal: 'Calibração Interna',
          clock: 'Relógio em massa',
          windows: 'Windows®Direct',
          iso: 'Relatório de Calibração ISO'
        },
        apps: {
          animal: 'Animal',
          gravity: 'Medição da gravidade específica',
          comparator: 'função de comparação',
          formulation: 'Modo de formulação',
          piece: 'Contagem de peças',
          carat: 'Medição de quilates'
        }
      }
    }
  }
}

export default Translate([balanceSearch])
